<template>
  <div class="island-badge" :class="type" @mouseover="showDragIcon = true" @mouseleave="showDragIcon = false">
    <div v-if="type === 'inputstring' && !showDragIcon">
      <QuestionIcon class="icon-1-3x" />
    </div>

    <div v-if="type === 'decision' && !showDragIcon">
      <DecisionIcon class="icon-1-5x" />
    </div>

    <div v-if="type === 'appintegration' && !showDragIcon">
      <font-awesome-icon icon="cube"></font-awesome-icon>
    </div>

    <!-- undraggables -->
    <div v-if="type === 'parentflows'">
      <FlowIcon class="icon-1-5x" />
    </div>

    <div v-if="type === 'linkedpaths'">
      <LinkedPathsIcon class="icon-1-5x fa-flip-vertical path-icon" />
    </div>

    <div v-if="type === 'quickreply'">
      <QuickReplyIcon class="icon-1-5x" />
    </div>

    <div v-if="type === 'trigger'">
      <TriggerIcon class="icon-1-5x" />
    </div>

    <div v-if="type === 'humanhandover'">
      <PauseBotIcon class="icon-1-5x" />
    </div>

    <div v-if="type === 'goto'">
      <GoToIcon class="icon-1-3x" />
    </div>

    <div v-if="type === 'text' && !showDragIcon" class="text-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="20"
        height="20"
        viewBox="0 0 172 172"
        style="fill: #000000"
      >
        <g
          fill="none"
          fill-rule="nonzero"
          stroke="none"
          stroke-width="1"
          stroke-linecap="butt"
          stroke-linejoin="miter"
          stroke-miterlimit="10"
          stroke-dasharray=""
          stroke-dashoffset="0"
          font-family="none"
          font-weight="none"
          font-size="none"
          text-anchor="none"
          style="mix-blend-mode: normal"
        >
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g fill="#ffffff">
            <path
              d="M85.83203,22.77656c-0.54801,0.01312 -1.09438,0.06551 -1.63489,0.15677h-44.0638h-5.73333c-3.1648,0 -5.73333,2.56853 -5.73333,5.73333v17.2c0,3.1648 2.56853,5.73333 5.73333,5.73333h5.73333c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-5.73333h28.66667v91.73333h-5.73333c-3.1648,0 -5.73333,2.56853 -5.73333,5.73333v5.73333c0,3.1648 2.56853,5.73333 5.73333,5.73333h15.34114c1.23099,0.20221 2.48672,0.20221 3.71771,0h15.34114c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-5.73333c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333h-5.73333v-91.73333h28.66667v5.73333c0,3.1648 2.56853,5.73333 5.73333,5.73333h5.73333c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-17.2c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333h-5.73333h-44.03021c-0.66226,-0.11084 -1.33298,-0.1633 -2.00442,-0.15677z"
            ></path>
          </g>
        </g>
      </svg>
    </div>

    <DragIcon v-if="draggable && showDragIcon" class="icon-1-5x"></DragIcon>
  </div>
</template>

<script lang="ts" setup>
import QuickReplyIcon from 'vue-material-design-icons/PlaylistCheck.vue';
import TriggerIcon from 'vue-material-design-icons/Flash.vue';
import QuestionIcon from 'vue-material-design-icons/ForumOutline.vue';
import LinkedPathsIcon from 'vue-material-design-icons/CallSplit.vue';
import PauseBotIcon from 'vue-material-design-icons/Pause.vue';
import DragIcon from '@/shared/components/DragIcon.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import DecisionIcon from 'vue-material-design-icons/SourceBranch.vue';
import GoToIcon from '@/shared/icons/GoToIcon.vue';
import { ref } from 'vue';

defineProps({
  type: {
    type: String,
    required: true,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
});
const showDragIcon = ref(false);
</script>

<style scoped lang="scss">
$color-action-green: #23d160;

.island-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border-radius: 5px 0 0 5px;
  cursor: move;
}

.trigger {
  background-color: $color-netcall-jonquil;
  color: $color-netcall-body-text;
  cursor: default;
}

.linkedpaths {
  background-color: $color-netcall-jonquil;
  color: $color-netcall-body-text;
  cursor: default;
}

.text {
  background-color: $color-netcall-deep-sea;
  color: white;
}

.inputstring {
  background-color: $color-netcall-salmon;
  color: white;
}

.decision {
  background-color: $color-action-green;
  color: white;
}

.quickreply {
  background-color: $color-netcall-salmon;
  color: white;
  cursor: default;
}

.appintegration {
  background-color: $color-action-green;
  color: white;
}

.humanhandover {
  background-color: $color-action-green;
  color: white;
  cursor: default;
}

.goto {
  background-color: $color-action-green;
  color: white;
  cursor: default;
}

.text-icon {
  margin-top: 5px;
}

.path-icon {
  top: 5px;
}
</style>
